import Alertas from '@/components/AAlertas.vue'
import Fecha from '@/components/AFecha.vue'
import PlanPagos from '@/components/AVer-cuotas.vue'
import PagarMatricula from '@/components/APagar-matricula.vue'
import PagarCuota from '@/components/APagar-cuota.vue'
import {generarContrato} from '@/components/generar-contrato.js'
import { Validator } from 'simple-vue-validator'
import gql from 'graphql-tag'
import {datFaltantes,isNullObject,error} from '@/components/Utils.js'

export default {
    data(){
        return {
            atras: '',
            activo: true,
            preinscribir: true,
            datosvalidos: true,
            msg: '',
            idNewInscripcion: 0,
            programa: {},
            inscripcion:{
                id: null,
                tipopago: false,
                matricula:{ monto:-1,fecha:"" },
                certificacion:{ monto:-1,fecha:"" },
                monto:{monto_colegiatura:-1,cuotas:null,fecha_ins:null,},
                observaciones: null,
            },
            matriculaCreada:{id:-1},
            cuotas_por_pagar:[],
            cuotas:[],
        }
    },
    components:{ 
        Alertas,Fecha,PlanPagos,
        PagarMatricula,PagarCuota
    },
    validators: {
        'inscripcion.tipopago'(value){ return Validator.value(value).required(); },
        'inscripcion.matricula.monto'(value){ return Validator.value(value).required().digit(); },
        'inscripcion.monto.monto_colegiatura'(value){ return Validator.value(value).required().digit(); },
        'inscripcion.certificacion.monto'(value){ return Validator.value(value).required().digit(); },
        'inscripcion.monto.cuotas'(value){ return Validator.value(value).digit().required(); },
        'inscripcion.observaciones'(value){ return Validator.value(value).minLength(0).regex("^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$"); },
    },
    watch:{
        'inscripcion.monto.cuotas': function(){
            this.lisCuotas();
        },
        inscripcion:{
            deep: true,
            handler(a){
                if(a==null) return;
                this.preinscribir = true;
                this.msg = '';
                this.$refs.alertar.reset();
                this.datosvalidos = false;
                window.sessionStorage.setItem( 'xinscripcion',JSON.stringify(this.inscripcion) );

                this.lisCuotas();
                
                if( a.monto.monto_colegiatura != null && a.monto.cuotas != null ){
                    var mensualidad = Math.trunc( Math.ceil(a.monto.monto_colegiatura / a.monto.cuotas) );
                    if( !isNaN(mensualidad) && isFinite(mensualidad) ){
                        var cole = parseInt(a.monto.monto_colegiatura);
                        var cuos = [];
                        var nro = 1;
                        var fecha = new Date();
                        var srtf = "";
                        while( cole-mensualidad > 0 ){
                            var ani = fecha.getFullYear();
                            var mes = fecha.getMonth()+1;
                            var dia = fecha.getDate();
                            if( mes < 10 ) mes = '0'+mes;
                            if( dia < 10 ) dia = '0'+dia;
                            cole = cole - mensualidad;
                            srtf = ani+"-"+mes+"-"+dia;
                            fecha.setMonth( mes );
                            fecha.setDate( 15 );
                            cuos.push( {monto:mensualidad,nro_cuota:nro,fecha:srtf} );
                            nro += 1;
                        }
                        if(cole>0){
                            ani = fecha.getFullYear();
                            mes = fecha.getMonth()+1;
                            dia = fecha.getDate();
                            if( mes < 10 ) mes = '0'+mes;
                            if( dia < 10 ) dia = '0'+dia;
                            srtf = ani+"-"+mes+"-"+dia;
                            fecha.setMonth( mes );
                            fecha.setDate( 15 );
                            cuos.push( {monto:cole,nro_cuota:nro,fecha:srtf} );
                        }
                        this.cuotas = cuos;
                        window.sessionStorage.setItem( "xcuotas",JSON.stringify(this.cuotas) );
                        this.preinscribir = false;
                    }
                }
            }
        }
    },
    methods:{
        lisCuotas(){
            if( this.inscripcion.monto.cuotas > 2 ) this.inscripcion.tipopago = false;
            else this.inscripcion.tipopago = true;
            window.console.log( "   ",this.inscripcion.tipopago );
        },
        xgenerarContrato(){
            if( this.inscripcion.idestudiante == null ){
                this.$notify( error( 'Contrato','Seleccione un Estudiante.' ) );
                return;
            }
            generarContrato( this.programa,this.cuotas,this.inscripcion.idestudiante )
        },
       
        validarCampos(){
            if( !this.activo ) return;
            this.activo = true;
            var vue = this;
            this.$validate().then((success) => {
                var obj = window.Object.assign({},this.inscripcion);
                
                if (success) {
                    vue.datosvalidos = true;
                    obj.matricula.monto = parseInt( obj.matricula.monto );
                    obj.certificacion.monto = parseInt( obj.certificacion.monto );
                    obj.monto.monto_colegiatura = parseInt( obj.monto.monto_colegiatura );
                    if( obj.tipopago || obj.tipopago == "true" ) obj.tipopago = true;
                    else obj.tipopago = false;

                    delete obj.idusuario;
                    this.$store.state.obj = obj;
                    this.$store.dispatch('quitarNulos');
                    this.$refs.alertar.cargando();
                    delete obj.monto;
                    
                        obj.cuotas = this.cuotas;
                        if( obj.matricula.fecha == "" || obj.certificacion.fecha == "" ){
                            this.$refs.alertar.invalido();
                            this.$notify( datFaltantes( "ERROR: ingrese las fechas de pago de matricula y certificacion" ) )
                        }else{
                            window.sessionStorage.setItem('obj',JSON.stringify(obj))
                            this.$dialog.confirm(this.$store.state.alertmsg).then(function() { vue.inscribir( obj )
                            }).catch(function() { vue.$refs.alertar.reset(); });
                        }
                    
                }else{
                    vue.datosvalidos = false;
                    this.$refs.alertar.invalido();
                }
            });
        },
        confirmado(){
            
        },
        inscribir( obj ){
            //window.console.log( "inscribir" );
            obj = JSON.parse( window.sessionStorage.getItem('obj') );
            var vue = this;
            var sql = gql`mutation{ updatePreInscripcion(input:${window.stringifyObject(obj)}){ ok,errors{message}} }`;
            vue.msg = '';
            window.console.log( sql );

            this.$apollo.mutate({
                mutation: sql,
            }).then((data) => {
                if(data.data.updatePreInscripcion.ok){
                    vue.$refs.alertar.success();
                    
                    window.sessionStorage.setItem( 'xinscripcion',null );
                }else{
                    var errores = JSON.stringify(data.data.updatePreInscripcion.errors);
                    var obj = JSON.parse( errores );
                    var vals = '';
                    obj.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
                    //vue.msg = vals;
                    vue.msg = '';
                    vue.activo = true;
                    vue.$refs.alertar.invalido( vals );
                }
                
                //window.console.log(data);
            }).catch((error) => {
                vue.$refs.alertar.invalido();
                this.activo = true;
                window.console.error(error);
                vue.msg = error;
            })
        },
    }, 
    mounted(){
      var xx = sessionStorage.preins;
      var toback = sessionStorage.toback;
      if( !toback ) toback = 'misinscripciones';
      this.atras = toback;
      var o = JSON.parse( xx );
      window.console.log( "-----------------",window.stringifyObject(o) )
        if( sessionStorage.xprograma != undefined ) {
            var ob1 = JSON.parse(sessionStorage.xprograma);
            if( !isNullObject(ob1) ) this.programa = ob1;
        }
        if( sessionStorage.xinscripcion != undefined ) {
            var ob = JSON.parse(sessionStorage.xinscripcion);
            if( !isNullObject(ob) ) this.inscripcion = ob;
        }
        /*if( isNullObject(ob1) ) {
            this.$notify( error( 'Error','No existe el programa seleccionado, vuelva atras y seleccione uno.' ) )
        }*/
        //window.console.log( window.stringifyObject(this.programa) )
        if( this.programa != null ){
            this.inscripcion.id = o.id;
            this.inscripcion.matricula.monto = this.programa.monto_matricula;
            this.inscripcion.certificacion.monto = this.programa.monto_certificacion;
            this.inscripcion.monto.monto_colegiatura = this.programa.monto_colegiatura;
            this.inscripcion.monto.cuotas = this.programa.cuotas;
            this.inscripcion.monto.fecha_ins = this.programa.fecha_inicio;
            delete this.inscripcion.idestudiante;
            delete this.inscripcion.idusuario;
            delete this.inscripcion.idprograma;
            var vue = this;
            setTimeout( function(){
                var ff = vue.programa.fecha_fin;
                var fi = vue.programa.fecha_inicio;
                vue.inscripcion.certificacion.fecha = ff;
                vue.inscripcion.matricula.fecha = fi;
                //window.console.log( "FECHA FINNNNN ",fi,window.stringifyObject(vue.inscripcion) )
            },3000)
        }

        this.lisCuotas();
    
    }
    
}